"use client";

import { Combobox } from "@/components/ui/combobox";
import type { Tag } from "@/lib/supabase/types";
import { useRouter, useSearchParams } from "next/navigation";
import { useState } from "react";

interface TagSelectorProps {
	tags: Tag[] | null;
}

export default function TagSelector({ tags }: TagSelectorProps) {
	const router = useRouter();
	const searchParams = useSearchParams();
	const currentTagsParam = searchParams.get("tags") || "";

	// Handle multiple cities from URL (comma-separated)
	const currentTags = currentTagsParam
		? currentTagsParam.split(",").map((tag) => tag.trim())
		: [];

	const [query, setQuery] = useState("");
	const [selectedTags, setSelectedTags] = useState<string[]>(currentTags);

	const handleChange = (selected: string[]) => {
		setSelectedTags(selected);
		const params = new URLSearchParams(searchParams.toString());

		if (selected) {
			if (Array.isArray(selected)) {
				// Handle multiple selection
				if (selected.length > 0) {
					const tagValues = selected.map((s) => s);
					params.set("tags", tagValues.join(","));
				} else {
					params.delete("tags");
				}
			} else {
				// Handle single selection
				params.set("tags", selected);
			}
		} else {
			params.delete("tags");
		}

		// Preserve other search parameters
		const queryString = params.toString();
		const href = queryString ? `/blog?${queryString}` : "/blog";

		router.push(href);
	};

	const filteredTags =
		query === ""
			? tags
			: tags?.filter((tag) => {
					return tag.name.toLowerCase().includes(query.toLowerCase());
				});

	return (
		<Combobox
			options={
				filteredTags?.map((tag) => ({
					value: tag.name,
					label: tag.name,
				})) || []
			}
			placeholder="Tags"
			selected={selectedTags}
			onChange={handleChange}
			className="h-7 text-xs px-1.5 gap-1"
		/>
	);
}
